import { useLayoutEffect, useState } from 'react';

/**
 * The rendered width of an element, live. The Portal Page breaks on its own width rather than
 * the viewport's so the editor can render it at 1280 or 390 inside a scaled box and get the
 * matching layout. `fixed` short-circuits the measurement (the preview knows its width); without
 * a ResizeObserver (tests) it falls back to the viewport width.
 */
export default function useContainerWidth(ref, fixed) {
  const [w, setW] = useState(() => fixed || (typeof window !== 'undefined' ? window.innerWidth : 1280));
  useLayoutEffect(() => {
    if (fixed) { setW(fixed); return undefined; }
    const el = ref.current;
    if (!el || typeof ResizeObserver !== 'function') {
      const onResize = () => setW(window.innerWidth);
      onResize();
      window.addEventListener('resize', onResize);
      return () => window.removeEventListener('resize', onResize);
    }
    const ro = new ResizeObserver(([e]) => { const next = Math.round(e.contentRect.width); if (next) setW(next); });
    ro.observe(el);
    const first = Math.round(el.getBoundingClientRect().width);
    if (first) setW(first);
    return () => ro.disconnect();
  }, [ref, fixed]);
  return w;
}
